import { useEffect, useMemo } from 'react';
import useAd from 'lib/hooks/useAd';
import { useDispatch } from 'react-redux';
import { adComponentReadyToReload } from 'redux-implementations/googleAds';
import { AdConfigBeforeInitialization } from 'types/AdConfig';
import { getAdSetup, reloadAd } from 'lib/GoogleAds/adManager';
// import useHashParamFeatureFlag from './useHashParamFeatureFlag';

export default function useConditionalRefreshAd(
  adConfig: AdConfigBeforeInitialization,
  load = true,
  shouldRefresh: boolean,
  onRefresh?: (id: string) => void
): { elementId: string; isShown: boolean } {
  const dispatch = useDispatch();
  const { elementId, isShown } = useAd(adConfig, load);
  const fullAdConfig = useMemo(() => ({ elementId, ...adConfig }), [elementId, adConfig]);
  const isAdManagerEnabled = getAdSetup();

  useEffect(() => {
    if (isShown && shouldRefresh && load) {
      if (isAdManagerEnabled) {
        reloadAd(fullAdConfig);
      } else {
        dispatch(adComponentReadyToReload(fullAdConfig));
      }

      if (onRefresh) {
        onRefresh(elementId);
      }
    }
  }, [
    isShown,
    shouldRefresh,
    fullAdConfig,
    dispatch,
    onRefresh,
    elementId,
    load,
    isAdManagerEnabled,
  ]);

  return { elementId, isShown };
}
